var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTextBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 225 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.007 5.42772C93.1103 4.4227 42.6378 4.99334 22.7877 9.25344C10.4137 11.9091 5 20.0008 5 42.4933C5 66.7647 15.8273 70.1186 22.7877 71.8882C42.8956 77.0004 110.953 71.8882 130.288 71.8882C149.622 71.8882 190.611 77 199.892 77C209.173 77 220 68.0538 220 37.3811C220 6.70937 197.573 6.70937 189.839 6.70937H189.838C182.104 6.70937 156.583 6.70937 121.007 5.42772Z",
    fill: "currentColor",
    stroke: "white",
    strokeWidth: 9
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextBg);
export default __webpack_public_path__ + "static/media/text_bg.4bca77db.svg";
export { ForwardRef as ReactComponent };